import React from 'react';
import { FaStethoscope, FaUserFriends, FaDollarSign, FaBuilding } from 'react-icons/fa';

const Card = ({ title, subtitle, Icon, iconColor, onClick, cardClass }) => (
  <button className={`menu-card ${cardClass || ''}`} onClick={onClick}>
    <div className="menu-icon" aria-hidden>
      <Icon className={`size-8 ${iconColor}`} />
    </div>
    <div className="menu-title">{title}</div>
    {subtitle && <div className="menu-subtitle">{subtitle}</div>}
  </button>
);

const ComplaintsMenu = ({ goBack, toOutcomes, toSettings, logout, onSelect }) => {
  return (
    <div className="menu-screen">
      <h1 className="menu-heading">Patient Complaint Report</h1>
      <p className="menu-sub">Select the category that best describes the complaint</p>
      <div className="menu-grid three-cols">
        <Card 
          title="Clinical Care" 
          subtitle="Treatment quality, pain management, and clinical outcomes" 
          Icon={FaStethoscope} 
          iconColor="text-indigo-600"
          onClick={() => onSelect('Complaint - Clinical Care')} 
          cardClass="clinical" 
        />
        <Card 
          title="Customer Service" 
          subtitle="Staff interactions, wait times, and service experience" 
          Icon={FaUserFriends} 
          iconColor="text-indigo-600"
          onClick={() => onSelect('Complaint - Customer Service')} 
          cardClass="customer" 
        />
        <Card 
          title="Billing/Financial" 
          subtitle="Insurance issues, payment problems, and billing concerns" 
          Icon={FaDollarSign} 
          iconColor="text-indigo-600"
          onClick={() => onSelect('Complaint - Billing/Financial')} 
          cardClass="billing" 
        />
        <Card 
          title="Facility/Environment" 
          subtitle="Office cleanliness, comfort, and facility-related issues" 
          Icon={FaBuilding} 
          iconColor="text-indigo-600"
          onClick={() => onSelect('Complaint - Facility/Environment')} 
          cardClass="facility" 
        />
      </div>
    </div>
  );
};

export default ComplaintsMenu;
